import { render, staticRenderFns } from "./GiveGiftCard.vue?vue&type=template&id=5bef2b9f&scoped=true"
import script from "./GiveGiftCard.vue?vue&type=script&lang=js"
export * from "./GiveGiftCard.vue?vue&type=script&lang=js"
import style0 from "./GiveGiftCard.vue?vue&type=style&index=0&id=5bef2b9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bef2b9f",
  null
  
)

export default component.exports